export default "__VITE_ASSET__DX7tgaIR__"